import React, { StrictMode } from 'react';
import './index.css';
import App from './App';
import './config/locale/i18n';
import { createRoot } from 'react-dom/client';

const container = document.getElementById('root');
const root = createRoot(container!);
root.render(
  <StrictMode>
    <App />
  </StrictMode>,
);
